import { render, staticRenderFns } from "./singleAuthentication.vue?vue&type=template&id=dc9135f4&"
import script from "./singleAuthentication.vue?vue&type=script&lang=js&"
export * from "./singleAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc9135f4')) {
      api.createRecord('dc9135f4', component.options)
    } else {
      api.reload('dc9135f4', component.options)
    }
    module.hot.accept("./singleAuthentication.vue?vue&type=template&id=dc9135f4&", function () {
      api.rerender('dc9135f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/wz/singleAuthentication.vue"
export default component.exports